import React, {useEffect} from 'react'
import {Redirect} from '@modifi/router'
import {InlineLoader, Row, Col} from '@modifi/ui'

import {NavigationItemEntry} from '../../types'

export type RouteEntrypointProps = {
  sectionName: string
  target?: NavigationItemEntry | null
  isLoading?: boolean
  init?: (sectionName: string) => void
  fallbackComponent?: React.ElementType
}

const RouteEntrypoint: React.FC<RouteEntrypointProps> = ({
  sectionName,
  target = null,
  isLoading = false,
  init,
  fallbackComponent,
}) => {
  useEffect(() => {
    if (init) {
      init(sectionName)
    }
  }, [init, sectionName])

  if (isLoading) {
    return (
      <Row justifyContent="center">
        <Col auto>
          <InlineLoader />
        </Col>
      </Row>
    )
  }

  if (!target || !target.route) {
    if (fallbackComponent) {
      const Component = fallbackComponent
      return <Component />
    }
    return null
  }

  return <Redirect to={target.route} />
}

export default RouteEntrypoint
